/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Newsletter_Optin_CooldownInputs */



/**
* | output |
* | --- |
* | "Too many attempts. Please try again in about {minutes} min." |
*
* @param {Newsletter_Optin_CooldownInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const newsletter_optin_cooldown = /** @type {((inputs: Newsletter_Optin_CooldownInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Optin_CooldownInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Zu viele Versuche. Bitte in etwa ${i?.minutes} min erneut versuchen.`)
	return /** @type {LocalizedString} */ (`Too many attempts. Please try again in about ${i?.minutes} min.`)
});